import TimelineItem from "./TimelineItem";
import { Element } from "react-scroll";

const Experience = () => {
  return (
    <Element name="experience" className="flex flex-col w-full px-4 lg:pt-24">
      <h1 className="lg:hidden flex text-xl font-WorkSans font-bold pt-16 pb-8 lg:pb-0 text-[#93a2b8]">
        Experience
      </h1>

      <TimelineItem
        visible="true"
        position="even"
        image="Images/tiaa_logo.webp"
        company="TIAA"
        duration="Jul 2024 – Present"
        role="Full Stack Developer"
        description="Working on enterprise-grade web applications using Spring Boot and Angular, focusing on building reliable backend services and intuitive user interfaces. Contribute to CI/CD pipelines using Jenkins and ensure application stability through testing and continuous improvements."
      />
      <TimelineItem
        visible="true"
        position="odd"
        image="Images/tiaa_logo.webp"
        company="TIAA"
        duration="Jun 2023 – Jul 2023"
        role="Full Stack Developer Intern"
        description="Led the development of an alert monitoring system as part of a cross-functional team. Analyzed system logs using Prometheus and Splunk to identify performance patterns, helping improve monitoring efficiency and system reliability."
      />
      <TimelineItem
        position="even"
        image="Images/zenix.jpg"
        company="Zenix"
        duration="Jul 2022 – Sep 2022"
        role="Full Stack Developer Intern"
        description="Developed a scalable web application using React and REST APIs, improving performance and responsiveness. Integrated modern frontend practices to enhance overall user experience and application reliability."
      />

      <a
        href="https://drive.google.com/file/d/11SVpBAUG0gmcPYO76FdIShp_wiqKgxy6/view?usp=sharing"
        target="_blank"
        rel="noreferrer" class="inline-block text-[#93a2b8] my-4">View Full Résumé<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" class="inline-block h-4 w-4 shrink-0 transition-transform group-hover/link:-translate-y-1 group-hover/link:translate-x-1 group-focus-visible/link:-translate-y-1 group-focus-visible/link:translate-x-1 motion-reduce:transition-none ml-1 translate-y-px" aria-hidden="true"><path fill-rule="evenodd" d="M5.22 14.78a.75.75 0 001.06 0l7.22-7.22v5.69a.75.75 0 001.5 0v-7.5a.75.75 0 00-.75-.75h-7.5a.75.75 0 000 1.5h5.69l-7.22 7.22a.75.75 0 000 1.06z" clip-rule="evenodd"></path></svg></a>

    </Element>
  );
};

export default Experience;
